<div *ngIf="!!activityHistory">
    <h4 class="mb-3">{{ 'Header.Activities' | translate }}</h4>
    <div class="activityHistoryItem item-{{i}} d-flex pb-3 mt-2" *ngFor="let x of activityHistory; let i = index">
        <div class="mr-3">
            <div class="hero-icon-circle-bg" *ngIf="!!x.icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="hero-icon-circle">
                    <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="x.icon"/>
                </svg>
            </div>
        </div>
        <div class="d-flex w-100">
            <div class="strokeVerticalLeft" *ngIf="i < activityHistory.length - 1"></div>
            <div class="iconHolder mr-3">
                <button class="btn btn-circle" [style.backgroundColor]="findColor('b', x.name)" [style.color]="findColor('c', x.name)">{{ findColor('letter', x.name) }}</button>
            </div>
            <div class="textHolder flex-column">
                <div class="d-flex">
                    <span class="text-bold mr-2">{{ x.name }}</span>
                    <span *ngIf="showText(x, 'translate')">{{ x.translateText | translate }}</span>
                    <span *ngIf="showText(x, 'text')">{{ x.text }}</span>
                </div>
                <div class="messageText ellipsis" *ngIf="!!x.subText">"{{ x.subText }}"</div>
                <div class="small-muted-text">{{ x.createdAt + 'Z' | date: 'longDate': '' : translate.currentLang }} {{ x.createdAt + 'Z' | date: 'HH:mm' }}</div>
            </div>
        </div>
    </div>
    <div class="text-center" *ngIf="view != 'full' && activityHistory.length > 9">
        <a class="cursor-pointer" (click)="switchTab()">{{ 'Standard.ShowMore' | translate }}</a>
    </div>
</div>